import Fetch from '../../../mixins/Fetch'

const updateAccount = async ({ commit }, params) => {
  const request = Fetch.post('user/updateaccount', params)

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const checkPassword = async ({ commit }, params) => {
  const request = Fetch.post('user/checkpassword', params)

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const loadEmpresasCriadas = async ({ commit }) => {
  const request = Fetch.get('infocliente/getownershipsowner')

  request.then(data => {
    commit('SETEMPREENDIMENTOS', data)
  })
}

const registerUser = async ({ commit }, params) => {
  const request = Fetch.post('infocliente/addsubclient', params)

  return request
}

export default {
  updateAccount,
  checkPassword,
  loadEmpresasCriadas,
  registerUser
}
